import axios from 'axios'
import helpers from "@/helpers";

export default {
    getDropdowns({commit}) {
        commit('setDropdownsState', 'loading')
        axios.get(process.env.VUE_APP_API_URL + '/dropdown/all')
            .then(response => {
                commit('storeDropdowns', response.data.data)
                commit('setDropdownsState', 'finished')
            })
            .catch(() => {
                commit('setDropdownsState', 'error')
            })
    },
    getDropdownById({commit}, dropdownId) {
        axios.get(process.env.VUE_APP_API_URL + '/dropdown/' + dropdownId)
            .then(response => commit('storeDropdown', response.data))
    },
    getSitesForDropdown({commit}, dropdownId) {
        commit('setSitesState', 'loading')
        axios.get(process.env.VUE_APP_API_URL + `/dropdown/${dropdownId}/site/all`)
            .then(response => {
                commit('storeSites', response.data.data)
                commit('setSitesState', 'finished')
            })
            .catch(() => {
                commit('setSitesState', 'error')
            })
    },
    getSiteById({commit}, siteId) {
        axios.get(process.env.VUE_APP_API_URL + '/site/' + siteId)
            .then(response => {
                commit('storeSite', response.data.data)
            })
            .catch((exception) => {
                console.error(exception)
            })
    },
    getNavigationSites({ commit }) {
        commit('setSitesState', 'loading')
        axios.get(process.env.VUE_APP_API_URL + '/site/null')
            .then(response => {
                commit('storeSites', response.data.data)
                commit('setSitesState', 'finished')
            })
            .catch(() => {
                commit('setSitesState', 'error')
            })
    },
    getSectionsForSite({commit}, siteId) {
        commit('setSectionsState', 'loading')
        axios.get(process.env.VUE_APP_API_URL + '/site/' + siteId + '/section/all')
            .then(response => {
                commit('storeSections', response.data.data)
                commit('setSectionsState', 'finished')
            })
            .catch(() => {
                commit('setSectionsState', 'error')
            })
    },
    getSectionById({commit}, sectionId) {
        axios.get(process.env.VUE_APP_API_URL + '/section/' + sectionId)
            .then(response => commit('storeSection', response.data.data))
    },
    storeSection({commit}, section) {
        let sectionDoup = JSON.parse(JSON.stringify(section))
        if (sectionDoup.type === "files" || sectionDoup.type === "slider") sectionDoup.content = JSON.stringify(sectionDoup.content)

        axios.put(process.env.VUE_APP_API_URL + `/section/${sectionDoup.id}`, sectionDoup)
            .then(() => {
                helpers.handleSuccessMessage("Der Inhalt wurde gespeichert.", "Gespeichert")
            })
        commit('none')
    },
    updateDropdownName({commit}, dropdown) {

        const dropdownData = {name: dropdown.name}
        axios.put(process.env.VUE_APP_API_URL + '/dropdown/' + dropdown.id, dropdownData)
            .then(() => helpers.handleSuccessMessage("Name gespeichert"))
            .catch(exception => helpers.handleMildAxiosError(exception))
        commit('none')
    },
    updateSiteName({commit}, site) {

        const siteData = {name: site.name}
        axios.put(process.env.VUE_APP_API_URL + '/site/' + site.id, siteData)
            .then(() => helpers.handleSuccessMessage("Name gespeichert"))
            .catch(exception => helpers.handleMildAxiosError(exception))
        commit('none')
    },
    createDropdown({commit, dispatch}, dropdownName) {

        const dropdown = {name: dropdownName}
        axios.post(process.env.VUE_APP_API_URL + '/dropdown', dropdown)
            .then(() => {
                helpers.handleSuccessMessage(`Dropdown '${dropdownName}' erstellt`)
                commit('clearDropdowns')
                dispatch('getDropdowns')
            })
            .catch(() => {
                helpers.handleWarningMessage("Das Dropdowns konnte nicht erstellt werden.")
            })
    },
    createSite({commit, dispatch}, { siteName, dropdown }) {

        let dropdown_id
        if (dropdown == null) {
            dropdown_id = null
        } else {
            dropdown_id = dropdown.id
        }
        const site = {name: siteName, dropdown_id}
        axios.post(process.env.VUE_APP_API_URL + '/site', site)
            .then(() => {
                helpers.handleSuccessMessage(`Seite '${siteName}' erstellt.`)
                commit('clearSites')
                if(dropdown !== undefined){
                    dispatch('getSitesForDropdown', dropdown.id)
                } else {
                    dispatch('getNavigationSites')
                }
                commit('clearDropdowns')
                dispatch('getDropdowns')
            })
    },
    createSection({commit, dispatch}, { site, name, type }) {

        let content = "Neuer Text"
        if (type === 'files' || type === 'slider') content = "[]"
        const section = { name, type, content}
        axios.post(process.env.VUE_APP_API_URL + '/site/' + site.id + '/section', section)
            .then(() => {
                helpers.handleSuccessMessage(`Teil '${name}' erstellt.`)
                commit('clearSections')
                dispatch('getSectionsForSite', site.id)
            })
            .catch(() => {
                helpers.handleWarningMessage("Etwas ist beim Erstellen schiefgelaufen.", "Fehler!")
            })
    },
    deleteDropdown({commit}, dropdownId) {

        axios.delete(process.env.VUE_APP_API_URL + '/dropdown/' + dropdownId)
            .then(() => {
                helpers.handleSuccessMessage("Dropdown gelöscht")
                commit('clearDropdowns')
                window.location = "/Navigation"
            })
            .catch(() => {
                helpers.handleWarningMessage("Dropdown konnte nicht gelöscht werden.")
            })
    },
    deleteSite({commit}, siteId) {

        axios.delete(process.env.VUE_APP_API_URL + '/site/' + siteId)
            .then(() => {
                helpers.handleSuccessMessage("Seite gelöscht")
                commit('clearSites')
                window.location = "/Navigation"
            })
            .catch(() => {
                helpers.handleWarningMessage("Die Seite konnte nicht gelöscht werden.")
            })
    },
    deleteSection({commit}, sectionId) {

        axios.delete(process.env.VUE_APP_API_URL + '/section/' + sectionId)
            .then(() => {
                helpers.handleSuccessMessage("Sektion gelöscht")
                commit('clearSections')
                window.location = "/Navigation"
            })
            .catch(() => {
                helpers.handleWarningMessage("Die Sektion konnte nicht gelöscht werden.")
            })
    },
    savePrivate({ commit }, { siteId, isPrivate}) {
        let message = 'Die Seite ist jetzt privat.'
        if(!isPrivate) {
            message = 'Die Seite ist jetzt öffentlich.'
        }
        const siteData = {private: isPrivate}
        axios.put(process.env.VUE_APP_API_URL + '/site/' + siteId, siteData)
            .then(() => helpers.handleSuccessMessage(message))
            .catch(exception => helpers.handleMildAxiosError(exception))
        commit('none')
    },
    saveDropdownPositions({commit, dispatch}, dropdowns) {
        axios.post(process.env.VUE_APP_API_URL + '/dropdowns/position', dropdowns)
            .then(() => {
                commit('clearDropdowns')
                dispatch('getDropdowns')
            })
    },
    saveSitePositions({commit, dispatch}, { sites, dropdownId}) {

        axios.post(process.env.VUE_APP_API_URL + '/sites/position', sites)
            .then(() => {
                commit('clearSites')
                if(dropdownId) {
                    dispatch('getSitesForDropdown', dropdownId)
                } else {
                    dispatch('getNavigationSites')
                }
            })
    },
    saveSectionPositions({commit, dispatch}, { sections, siteId}) {

        axios.post(process.env.VUE_APP_API_URL + '/sections/position', sections)
            .then(() => {
                commit('clearSections')
                dispatch('getSectionsForSite', siteId)
            })
    }
}
